import ReactECharts from 'echarts-for-react';
import echarts from '../echarts';
import { IMPACT_NODES, IMPACT_LINKS } from '../data/mockData';

// 区块9：影响力生态网络图
export default function ChartNetworkImpact() {
  const categories = [
    { name: '核心平台', itemStyle: { color: '#fbbf24' } },
    { name: '直接服务对象', itemStyle: { color: '#06b6d4' } },
    { name: '生态合作伙伴', itemStyle: { color: '#22c55e' } },
  ];

  const option = {
    backgroundColor: 'transparent',
    title: {
      text: '数师有方影响力生态网络',
      left: 'center',
      textStyle: { color: '#fbbf24', fontSize: 20, fontWeight: 'bold' },
    },
    tooltip: {
      backgroundColor: 'rgba(15, 23, 42, 0.9)',
      borderColor: '#fbbf24',
      textStyle: { color: '#fff' },
    },
    legend: {
      data: categories.map((c) => c.name),
      bottom: 0,
      textStyle: { color: '#cbd5e1', fontSize: 14 },
    },
    series: [
      {
        type: 'graph',
        layout: 'force',
        data: IMPACT_NODES.map((node) => ({
          ...node,
          itemStyle: {
            color: categories[node.category].itemStyle.color,
            shadowBlur: 24,
            shadowColor: categories[node.category].itemStyle.color,
          },
          label: {
            show: true,
            color: '#fff',
            fontSize: 14,
            fontWeight: 'bold',
          },
        })),
        links: IMPACT_LINKS.map((link) => ({
          ...link,
          lineStyle: {
            color: '#fbbf24',
            width: 2,
            curveness: 0.05,
          },
        })),
        categories,
        roam: true,
        force: {
          repulsion: 500,
          edgeLength: [80, 180],
          gravity: 0.15,
        },
        emphasis: {
          focus: 'adjacency',
          lineStyle: { width: 4 },
        },
        lineStyle: {
          color: 'source',
          curveness: 0.05,
        },
        animationDuration: 2000,
        animationEasing: 'cubicOut',
      },
    ],
  };

  return (
    <ReactECharts
      echarts={echarts}
      option={option}
      style={{ width: '100%', height: '100%', minHeight: 420 }}
      opts={{ renderer: 'svg' }}
    />
  );
}
